import { useQuery } from "@tanstack/react-query";

import { trackingPublicConfigQueryOptions } from "~/lib/tracking/config";
import { openConsentPreferences } from "~/lib/tracking/consent";

/**
 * Botón "Cambiar mis preferencias de cookies" para las páginas legales. Sólo existe con el aviso
 * de cookies prendido (`TRACKING_CONSENT_BANNER=on`): con el aviso apagado no hay panel que abrir
 * y la exclusión se hace con «No medir en este navegador» (`MeasurementOptOut`). En SSR y en el
 * primer render del cliente la config todavía no llegó: no se muestra (sin mismatch).
 */
export function CookiePreferencesButton() {
  const { data } = useQuery(trackingPublicConfigQueryOptions);
  if (data?.consentBanner !== true) return null;

  return (
    <button
      type="button"
      onClick={openConsentPreferences}
      data-testid="privacy-cookie-preferences"
      className="mt-1 inline-flex h-10 items-center rounded-[8px] border border-landing-text/70 px-4 text-[14px] font-semibold text-landing-text transition-colors hover:bg-landing-stone-100"
    >
      Cambiar mis preferencias de cookies
    </button>
  );
}
